import {
  Box, BoxProps, styled,
} from '@mui/material';
import { scrollbarStyle1 } from '../../../styles/scrollbarStyles';
import { spaceCadet } from '../../../utils/colors';

const StyledBox = styled((props: BoxProps) => {
  const { children, ...other } = props;
  return (
    <Box {...other}>
      <Box>{children}</Box>
    </Box>
  );
})(() => ({
  height: '100%',
  '& > .MuiBox-root': {
    backgroundColor: spaceCadet[100],
    minWidth: 200,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    alignItems: 'stretch',
    height: '100%',

    // PanelTabs + .content share ONE box (.tabsPanel) so the tab bar and
    // the panel content read as one continuous surface, not two separately
    // margined siblings that have to be kept in sync by hand.
    '& > .MuiBox-root.tabsPanel': {
      backgroundColor: 'white',
      margin: '4px 8px 0',
      flexGrow: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      border: `1px solid ${spaceCadet[300]}`,
      borderRadius: 8,

      '& > .MuiBox-root.content': {
        flexGrow: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  ...scrollbarStyle1,
}));

export default StyledBox;
